import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {
    ArcElement,
    CategoryScale,
    Chart as ChartJS,
    defaults,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip
} from "chart.js";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {
    ThinAccountBalanceIcon,
    ThinCreditCardTimeIcon,
    ThinCreditScoreIcon,
    ThinnerPeopleIcon,
    ThinTimeIcon
} from "../../../components/icons/material-icons";
import {CurrencyFormat} from "../../../components/techaran/money";
import {AnalyticsCard} from "../store/store";
import {Doughnut} from "react-chartjs-2";

defaults.font.family = 'estedad';
ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
);

export const AdminsPresignupInsightsScreen = () => {
    useEffect(() => {
        document.title = "آمار | پیش ثبت‌نام | نهال";
        fetchData();
    }, []);
    const [data, setData] = useState({
        totalPaid: 0,
        totalHadToBePaid: 0,
        signupCount: 0,
        paidCount: 0,
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/presignup/stats',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                totalPaid: number,
                totalHadToBePaid: number,
                signupCount: number,
                paidCount: number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                setData({
                    paidCount: d.paidCount,
                    signupCount: d.signupCount,
                    totalPaid: d.totalPaid,
                    totalHadToBePaid: d.totalHadToBePaid,
                });
                setCountChart({
                    numbers: [d.signupCount - d.paidCount, d.paidCount],
                    labels: ['عدم پرداخت', 'تکمیل پرداخت'],
                    borderColors: [
                        'rgba(100,0,0,0.4)', 'rgba(0,150,0,0.8)',
                    ],
                    backgroundColors: [
                        'rgba(255,0,0,0.2)', 'rgba(0,200,0,0.2)',
                    ],
                });
                setTotalChart({
                    numbers: [d.totalHadToBePaid - d.totalPaid, d.totalPaid],
                    labels: ['بدهکاری', 'پرداخت شده'],
                    borderColors: [
                        'rgba(100,0,0,0.4)', 'rgba(0,150,0,0.8)',
                    ],
                    backgroundColors: [
                        'rgba(255,0,0,0.2)', 'rgba(0,200,0,0.2)',
                    ],
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [loaded, setLoaded] = useState(false);
    const [countChart, setCountChart] = useState({
        backgroundColors: [] as string[],
        borderColors: [] as string[],
        numbers: [] as number[],
        labels: [] as string[],
    });
    const [totalChart, setTotalChart] = useState({
        backgroundColors: [] as string[],
        borderColors: [] as string[],
        numbers: [] as number[],
        labels: [] as string[],
    });
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'پیش ثبت‌نام', url: '/admins/presignup'},
                {title: 'آمار', url: '/admins/presignup/insights'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="d-flex justify-content-between align-items-center"
                             style={{padding: '30px 15px 5px 15px'}}>
                            <h1 className="page-title" style={{margin: 0}}>
                                آمار پیش ثبت‌نام
                                <span className="f-roboto">آمار و نمودار های حسابداری پیش ثبت‌نام مدرسه.</span>
                            </h1>
                        </div>
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="row acc-analytics" style={{marginTop: 20}}>
                                    <AnalyticsCard
                                        value={data.totalPaid.toString()}
                                        isMoney={true}
                                        icon={<ThinAccountBalanceIcon/>}
                                        text={"کل مبلغ پرداخت شده"}
                                        onClick={null}
                                    />
                                    <AnalyticsCard
                                        value={(data.totalHadToBePaid - data.totalPaid).toString()}
                                        isMoney={true}
                                        icon={<ThinTimeIcon/>}
                                        text={"کل مبلغ باقی‌مانده"}
                                        onClick={null}
                                    />
                                    <AnalyticsCard
                                        value={CurrencyFormat(data.signupCount)}
                                        isMoney={false}
                                        icon={<ThinnerPeopleIcon/>}
                                        text={"تعداد کل ثبت‌نام شده"}
                                        onClick={null}
                                    />
                                    <AnalyticsCard
                                        value={CurrencyFormat(data.paidCount)}
                                        isMoney={false}
                                        icon={<ThinCreditScoreIcon/>}
                                        text={"تعداد تسویه حساب شده"}
                                        onClick={null}
                                    />
                                    <AnalyticsCard
                                        value={CurrencyFormat(data.signupCount - data.paidCount)}
                                        isMoney={false}
                                        icon={<ThinCreditCardTimeIcon/>}
                                        text={"تعداد بدهکاران"}
                                        onClick={null}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="dashboard--chart">
                                    <b>نمودار تعداد تسویه‌حساب شده</b>
                                    <Doughnut data={{
                                        labels: countChart.labels,
                                        datasets: [
                                            {
                                                label: 'دانش‌آموز',
                                                data: countChart.numbers,
                                                backgroundColor: countChart.backgroundColors,
                                                borderColor: countChart.borderColors,
                                                borderWidth: 1,
                                            },
                                        ],
                                    }}/>
                                </div>
                                <div className="dashboard--chart">
                                    <b>نمودار میزان بدهی/پرداختی</b>
                                    <Doughnut data={{
                                        labels: totalChart.labels,
                                        datasets: [
                                            {
                                                label: 'تومان',
                                                data: totalChart.numbers,
                                                backgroundColor: totalChart.backgroundColors,
                                                borderColor: totalChart.borderColors,
                                                borderWidth: 1,
                                            },
                                        ],
                                    }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }
        </>
    );
};